import { Component, Input, OnInit, ViewChild } from '@angular/core';

import { Modal } from '../../../models/qa.model';
import { StartupService } from '../../../services/startup.service';
import { QaService } from '../../../services/qa.service';
import { AnswerInfoService } from '../../../services/answer-info.service';

@Component({
  selector: 'app-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss']
})
export class ModalComponent implements OnInit {
  @Input() modal: Modal;
  @ViewChild('popup') popup;

  constructor(
    public startupService: StartupService,
    public qaService: QaService,
    private answerInfoService: AnswerInfoService
  ) { }

  ngOnInit() {
    const image = this.startupService.startupData.PopupImages.find(i =>
          i.PopupFilter === this.modal.PopupFilter &&
          i.WoodType === this.answerInfoService.getSelectedWoodType()
         );
    if (image !== undefined) {
      this.modal.Image = image.PopupImage;
    }

    this.modal.currentMessage.subscribe(x => {
      if (!x) {
        this.popup.nativeElement.style.bottom = (window.innerHeight / 2) - (this.popup.nativeElement.clientHeight / 2) + 'px';
      } else {
        this.popup.nativeElement.style.bottom = '-200%';
      }
    });
  }

  imageExist() {
    return this.modal.Image != null;
  }
}



// WEBPACK FOOTER //
// ./src/app/components/shared/modal/modal.component.ts